module.exports = __webpack_public_path__ + "static/img/h4-1.aa6e956.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner1/h4-1.png
// module id = ofVO
// module chunks = 1